module.exports = __webpack_public_path__ + "static/media/cross.5a9cb122.png";